<template>
  <div class="is-active modal">
    <div class="modal-background"
         @click="handleBackgroundClick" />
    <div class="modal-card rounded-borders">
      <div class="modal-card-body is-flex-direction-column">
        <div class="mb-2">
          <button v-if="!hideCloseButton"
                  class="is-pulled-right delete"
                  aria-label="close"
                  @click="close" />
          <div class="title-five">
            <slot name="title" />
          </div>
        </div>

        <slot name="body" />
      </div>
      <footer v-show="!hideActions"
              class="modal-card-foot justify-to-end">
          <slot name="actions">
            <button class="button" @click="close">
              <span>{{ i18n.global.t('close') }}</span>
            </button>
          </slot>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import i18n from '@/locales'
import { useComposableForEsc } from '@/components/common/modal/useComposableForEsc'

const props = defineProps({
  hideActions: Boolean,
  hideCloseButton: Boolean,
  disableBackgroundClick: Boolean,
  disableEscKey: Boolean
})

useComposableForEsc({
  dismissFunction: () => {
    if (!props.disableEscKey) {
      close()
    }
  }
})

const emit = defineEmits(['close'])

const close = () => emit('close')

const handleBackgroundClick = () => {
  if (!props.disableBackgroundClick) {
    close()
  }
}
</script>

<style scoped lang="scss">
.justify-to-end {
  justify-content: end;
}

.rounded-borders {
  border-radius: 6px;
}
</style>
